import { render } from "./CIImage.vue?vue&type=template&id=1f440cd3&scoped=true&ts=true"
import script from "./CIImage.vue?vue&type=script&lang=ts"
export * from "./CIImage.vue?vue&type=script&lang=ts"

import "./CIImage.vue?vue&type=style&index=0&id=1f440cd3&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f440cd3"]])

export default __exports__